export default "__VITE_ASSET__Cn31SLMW__"